// Import vue component
import VImageInput from 'vuetify-image-input';
import BulbSettings from './BulbSettings.vue';
import ImageUpload from './components/ImageUpload.vue';
import Tooltip from '../../../snippets/vue/Tooltip.vue';
import AsyncComputed from 'vue-async-computed';

// install function executed by Vue.use()
function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('v-image-input', VImageInput);
  Vue.component('PlaypositImageUpload', ImageUpload);
  Vue.component('PlaypositBulbSettings', BulbSettings);
  Vue.component('Tooltip', Tooltip);
  Vue.use(AsyncComputed);
}

// Create module definition for Vue.use()
const plugin = {
  install,
};

// To auto-install when vue is found
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

// Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
if (GlobalVue) {
  GlobalVue.use(plugin);
}

BulbSettings.install = install;

// Export component by default:
export default BulbSettings;
